import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import Icon from '../components/Icon';
import '../styles/AuthPages.css';

function SetupProfilePage({ onSetup, onLogout }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [firstname, setFirstname] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    if (onLogout) {
      await onLogout();
    }
    navigate('/login');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.setupProfile(username, email, password, firstname, surname);
      onSetup(response.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Profile setup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-logo">
          <div className="bike-icon">
            <Icon name="bike" color="primary" darkMode={false} size={48} />
          </div>
          <h1>Frame-Book</h1>
          <p>Welcome! Let's set up your profile</p>
        </div>

        <div className="auth-card">
          {/* Testing Guide */}
          <div className="testing-guide" style={{padding: '15px', marginBottom: '20px', fontSize: '14px'}}>
            <h4 style={{marginTop: 0, marginBottom: '10px', color: '#ffffff'}}>🧪 TESTING GUIDE</h4>
            <p style={{margin: '5px 0', color: '#ffffff'}}><strong>What you see:</strong> Profile setup page for frame number-based accounts to set username, email, and password.</p>
            <p style={{margin: '5px 0', color: '#ffffff'}}><strong>What you can do:</strong> 
              <ul style={{margin: '5px 0', paddingLeft: '20px', color: '#ffffff'}}>
                <li>Set a username (cannot be the frame number)</li>
                <li>Add your email address</li>
                <li>Choose your password</li>
                <li>Enter your name</li>
              </ul>
            </p>
            <p style={{margin: '5px 0', color: '#ffffff'}}><strong>Important:</strong> This page only appears after the first login with a frame number-based account. After setup, it will no longer show.</p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
            <button 
              type="button" 
              onClick={handleLogout} 
              className="btn btn-secondary"
              style={{ marginRight: 'auto' }}
            >
              ← Log out
            </button>
            <h2 style={{ margin: '0 auto', color: '#111827' }}>Complete Your Profile</h2>
            <div style={{ width: '150px' }}></div>
          </div>
          <p className="help-text">
            Your bike has been serviced with Frame-Book. 
            Please create your personal account details.
          </p>
          
          {error && <div className="error">{error}</div>}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                required
                disabled={loading}
                placeholder="Your first name"
              />
            </div>

            <div className="form-group">
              <label>Surname</label>
              <input
                type="text"
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
                required
                disabled={loading}
                placeholder="Your surname"
              />
            </div>

            <div className="form-group">
              <label>New Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                disabled={loading}
                placeholder="Choose a username"
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                placeholder="Enter your email"
              />
            </div>

            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                placeholder="Choose a password"
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading}
                placeholder="Confirm your password"
              />
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Setting up...' : 'Complete Setup'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SetupProfilePage;

